/**
 * Observes the visibility of the main add-to-cart button and toggles
 * a class on the sticky button accordingly.
 */
function setupStickyButtonToggle() {
	const mainButton = document.querySelector(
		'.add-to-cart-for-body-class .single_add_to_cart_button,.add-to-cart-for-body-class .cwginstock-subscribe-form .cwgstock_button'
	);
	// Look for sticky button in both the pattern wrapper and the PHP-generated wrapper
	const stickyButton = document.querySelector(
		'.sticky-add-to-cart .sticky-add-to-cart-trigger, .sticky-add-to-cart-wrapper .sticky-add-to-cart-trigger'
	);

	// Stop if either button isn't found yet
	if (!mainButton || !stickyButton) {
		// console.warn('Main or sticky button not found, retrying...');
		setTimeout(setupStickyButtonToggle, 500);
		return;
	}

	// Click handler: trigger the main form's add to cart button
	stickyButton.addEventListener('click', (e) => {
		e.preventDefault();
		e.stopPropagation();

		// Scroll to form and trigger click on main button
		// This will show the WooCommerce alert if variation not selected
		const form = document.querySelector('.add-to-cart-for-body-class');
		if (form) {
			form.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}

		// Trigger click on the main button - WooCommerce will handle the alert
		mainButton.click();
	});

	// Sync disabled state from main button to sticky button
	function syncButtonState() {
		if (mainButton.classList.contains('disabled') || mainButton.classList.contains('wc-variation-selection-needed')) {
			stickyButton.classList.add('disabled', 'wc-variation-selection-needed');
		} else {
			stickyButton.classList.remove('disabled', 'wc-variation-selection-needed');
		}
	}

	// Initial sync
	syncButtonState();

	// Observe class changes on main button
	const buttonObserver = new MutationObserver(syncButtonState);
	buttonObserver.observe(mainButton, { attributes: true, attributeFilter: ['class'] });

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Main button visible → hide sticky
					stickyButton.classList.remove('is-visible');
				} else {
					// Main button out of view → show sticky
					stickyButton.classList.add('is-visible');
				}
			});
		},
		{
			root: null,
			rootMargin: '0px',
			threshold: 0.01,
		}
	);

	observer.observe(mainButton);
}

document.addEventListener('DOMContentLoaded', setupStickyButtonToggle);
